import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function PaymentCancelled() {
  const navigate = useNavigate();

  return (
    <div className="app">
      <Header />
      <main style={{ padding: '100px 0', textAlign: 'center', background: 'var(--bg-1)', minHeight: '70vh' }}>
        <div className="wrap" style={{ maxWidth: '600px' }}>
          <XCircle size={64} style={{ color: '#ff4444', marginBottom: '24px' }} />
          <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Payment Cancelled</h1>
          <p style={{ color: 'var(--text-2)', fontSize: '1.2rem', marginBottom: '40px' }}>
            The payment process was cancelled. No charges were made.
          </p>
          <button 
            onClick={() => navigate('/pricing')}
            className="btn-secondary"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', padding: '16px 32px' }}
          >
            <ArrowLeft size={18} /> Back to Pricing
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
